export const wrapToArray = (value: any | Array<any>) => {
  if (Array.isArray(value)) return value;
  return [value];
};
